import { useEffect, useState } from "react";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { _AbstractAccount, _AccountINFORPO, _PayrollEntityProperties, _RequestCredit, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { CreditDetailsToken } from "./Components/CreditDetailsToken";
import { PrintJson } from "../../../../theme/Component/PrintJson";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    Token: string;
    Obs: string;
    Approve: string;
    discountCode: number;
}

export const CC012 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_RequestCredit);
    const payroll = useDataBean(_PayrollEntityProperties);

    const [props, setProps] = useState<any>({});
    const [response, setResponse] = useState<Resp>({
        Token: "",
        Obs: "",
        Approve: "",
        discountCode: null,
    })

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
        getReuqest();
    }, [configProcedure?._pocessData])

    const onExportMap = () => {

        instance.updateRequestCredit({
            ...bean,
            TokenCuota: response.Token,
            DiscountCode: response.discountCode,
            AnalistConcep: response.Obs
        });

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(
                _single.jsonToBootstrapTable({
                    "Token Asignado": response.Token,
                    "Observaciones": response.Obs,
                })
            )
        }

        if (configProcedure?._pushProps) {
            configProcedure?._pushProps({ Token: response.Token })
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(response)
        }

    }

    const getReuqest = () => {
        const props = {
            IDProcedureImp: configProcedure._procedure.IDProcedureImp
        }
        instance.getRequestCreditCatalogPorPropiedades(props, null).then(
            (resp) => {
                setBean(resp[0].DataBeanProperties)
                const x = resp[0].DataBeanProperties;
                if (x.AnalistConcep) {
                    setResponse({ ...response, Obs: x.AnalistConcep })
                }
                if (x.JSONDeudor) {
                    const userCaja = resp[0].DataBeanProperties.JSONDeudor ? JSON.parse(resp[0].DataBeanProperties.JSONDeudor) : {};

                    if (userCaja.IDCajaNominadora) {
                        const props = { IDPayrollEntity: userCaja.IDCajaNominadora };
                        payroll.instance.getPayrollEntityPropertiesCatalogPorPropiedades(props, null).then(
                            (resp) => {
                                if (resp.length > 0) {
                                    const x = resp[0].DataBeanProperties?.JSONCodeDiscount
                                        ? JSON.parse(resp[0].DataBeanProperties?.JSONCodeDiscount)
                                        : [];
                                    payroll.setLista(x);
                                }
                            }
                        ).catch(
                            err => { toast.error(err); }
                        );
                    }
                }
            }
        ).catch(err => {
            toast.error(err)
        })
    }

    useEffect(() => {
        if (response.Approve !== "") {
            onExportMap();
        }
    }, [response]);

    const updateForm = (app: string) => {
        setResponse(prev => ({ ...prev, Approve: app }));
    }


    return (
        <div className="row">
            <div className="col-md-6">
                <label>Token Asignado</label>
                <input type="text" className="form-control" value={response.Token} onChange={(e) => { setResponse({ ...response, Token: e.target.value }) }} />
            </div>
            <div className="col-md-6">
                <label >Codigo de Descuento</label>
                <select className="form-select" value={response.discountCode} onChange={(e) => { setResponse({ ...response, discountCode: parseInt(e.target.value) }) }}>
                    <option value="">...</option>
                    {payroll.lista.map((item, index) => {
                        return (
                            <option key={index} value={item.DiscountCode}>{item.DiscountName}</option>
                        )
                    })}
                </select>
            </div>
            <div className="col-md-12">
                <label>Observaciones</label>
                <textarea className="form-control" rows={5} value={response.Obs} onChange={(e) => { setResponse({ ...response, Obs: e.target.value }) }} />
            </div>

            <div className="col-md-12 mt-2">
                <CreditDetailsToken
                    objectUpdate={bean}
                    onUpdate={() => { getReuqest(); }}
                    pushProps={(e) => configProcedure?._pushProps(e)}
                    Props={{
                        Codeudor: bean.JSONCodeuda ? JSON.parse(bean.JSONCodeuda) : {},
                        Credito: bean.JSONCredit ? JSON.parse(bean.JSONCredit) : {},
                        Notas: bean.JSONNotes ? JSON.parse(bean.JSONNotes) : {},
                        CheckList: bean.JSONCheckList ? JSON.parse(bean.JSONCheckList) : {},
                        JSONDeudor: bean.JSONDeudor ? JSON.parse(bean.JSONDeudor) : {},
                        RProps: props
                    }}
                />
            </div>

            <div className="col-md-6">
                <BasicButton icon="ri-checkbox-circle-line" eventClick={() => {
                    if (response.Token && response.discountCode) {
                        updateForm("true")
                    } else {
                        toast.error("Token no valido o codigo de descuento")
                    }
                }} >Enviar a Comite</BasicButton>
            </div>
            <div className="col-md-6 d-flex justify-content-end position-relative">
                <div className="btn-group" role="group">
                    <button
                        id="btnGroupReject"
                        type="button"
                        className="btn btn-danger dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        Rechazar
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="btnGroupReject">
                        <li>
                            <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (response.Token) {
                                        updateForm("false");
                                    } else {
                                        toast.error("Token no valido")
                                    }

                                }}
                            >
                                Archivar
                            </a>
                        </li>
                        <li>
                            <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (response.Token) {
                                        updateForm("Return");
                                    } else {
                                        toast.error("Token no valido")
                                    }
                                }}
                            >
                                Devolver Analista
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};